export default __webpack_public_path__ + "static/media/polygon-circumference2.328027eb.svg";